var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.897,0.858c0.04,-0.34 -0.15,-0.667 -0.466,-0.799c-0.315,-0.132 -0.68,-0.037 -0.893,0.231l-6.372,8.061c-0.183,0.231 -0.217,0.546 -0.09,0.811c0.128,0.266 0.395,0.434 0.689,0.434l4.874,0c-0,0 -0.536,4.515 -0.536,4.515c-0.04,0.341 0.15,0.668 0.466,0.8c0.315,0.132 0.68,0.037 0.893,-0.232l6.372,-8.06c0.183,-0.231 0.217,-0.546 0.09,-0.811c-0.128,-0.266 -0.395,-0.434 -0.689,-0.434l-4.874,-0c0,-0 0.536,-4.516 0.536,-4.516Zm-1.838,2.509l-0.318,2.684c-0.026,0.218 0.042,0.436 0.187,0.6c0.145,0.164 0.353,0.258 0.572,0.258l4.152,0c0,0 -3.711,4.694 -3.711,4.694c0,0 0.318,-2.684 0.318,-2.684c0.026,-0.218 -0.042,-0.436 -0.187,-0.6c-0.145,-0.164 -0.353,-0.258 -0.572,-0.258l-4.152,-0l3.711,-4.694Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZap);
export default __webpack_public_path__ + "static/media/Zap.8b39ddb0f3796ab8894b47a778f05b91.svg";
export { ForwardRef as ReactComponent };